import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../constants/routes';

import DashboardLayout from '../components/Layout/DashboardLayout';
import RequireAuth from '../routes/RequireAuth';
import SuspenseWrapper from './SuspenseWrapper';
import NotFoundPage from './NotFoundPage';

const ManageCatelog = lazy(() => import('../pages/Catalog/ManageCatalog'));
const Homepage = lazy(() => import('../pages/Homepage/Homepage'));
const Login = lazy(() => import('../pages/Authentication/Login'));
const Register = lazy(() => import('../pages/Authentication/Register'));
const RegisterPage = lazy(() =>
  import('../pages/Authentication/Register/RegisterPage')
);
const PaidService = lazy(() => import('../pages/PaidService'));
const Subscription = lazy(() => import('../pages/PaidService/Subscription'));
const BBS = lazy(() => import('../pages/BBS'));
const BuyLeads = lazy(() => import('../pages/ByLeads'));
const ManageLeads = lazy(() => import('../pages/ManageLeads/ManageLeads'));
const ManageLeadDetails = lazy(() =>
  import('../pages/ManageLeads/ManageLeadDetails')
);
const ForgotPassword = lazy(() =>
  import('../pages/Authentication/forgotPassword')
);
const UpdatePassword = lazy(() =>
  import('../pages/Authentication/UpdatePassword')
);
const CatelogViews = lazy(() => import('../pages/CatelogViews'));
const LoginNew = lazy(() => import('../pages/Authentication/LoginNew'));
const PhotosAndDocs = lazy(() =>
  import('../pages/PhotosAndDocs/PhotosAndDocs')
);
const ContactInfo = lazy(() => import('../pages/ContactInfo'));
const Settings = lazy(() => import('../pages/Settings'));
const PageRoutes = () => {
  return (
    <Routes>
      <Route
        path={ROUTES.LOGIN}
        element={
          <SuspenseWrapper>
            <LoginNew />
          </SuspenseWrapper>
        }
      />
      <Route
        path={ROUTES.FORGOTPASSWORD}
        element={
          <SuspenseWrapper>
            <ForgotPassword />
          </SuspenseWrapper>
        }
      />
      <Route
        path={ROUTES.RESET_PASSWORD}
        element={
          <SuspenseWrapper>
            <UpdatePassword />
          </SuspenseWrapper>
        }
      />
      <Route
        path={ROUTES.REGISTER}
        element={
          <SuspenseWrapper>
            <RegisterPage />
          </SuspenseWrapper>
        }
      />
      <Route
        element={
          <RequireAuth>
            <DashboardLayout />
          </RequireAuth>
        }
      >
        <Route
          path={ROUTES.CATELOG_VIEWS}
          element={
            <SuspenseWrapper>
              <CatelogViews />
            </SuspenseWrapper>
          }
        />
        <Route
          path={ROUTES.CATELOG}
          element={
            <SuspenseWrapper>
              <ManageCatelog />
            </SuspenseWrapper>
          }
        />
        <Route
          path={ROUTES.MANAGE_LEADS}
          element={
            <SuspenseWrapper>
              <ManageLeads />
            </SuspenseWrapper>
          }
        />
        <Route
          path={ROUTES.PHOTOS_DOCS}
          element={
            <SuspenseWrapper>
              <PhotosAndDocs />
            </SuspenseWrapper>
          }
        />
        <Route
          path={ROUTES.MANAGE_LEADS_DETAILS}
          element={
            <SuspenseWrapper>
              <ManageLeadDetails />
            </SuspenseWrapper>
          }
        />
        <Route
          path={ROUTES.BBS}
          element={
            <SuspenseWrapper>
              <BBS />
            </SuspenseWrapper>
          }
        />

        <Route
          path={ROUTES.BUY_LEAD}
          element={
            <SuspenseWrapper>
              <BuyLeads />
            </SuspenseWrapper>
          }
        />
        <Route
          path={ROUTES.HOMEPAGE}
          element={
            <SuspenseWrapper>
              <Homepage />
            </SuspenseWrapper>
          }
        />
        <Route
          path={ROUTES.PAID_SERVICE}
          element={
            <SuspenseWrapper>
              <PaidService />
            </SuspenseWrapper>
          }
        />
        <Route
          path={ROUTES.SUBSCRIPTION}
          element={
            <SuspenseWrapper>
              <Subscription />
            </SuspenseWrapper>
          }
        />
        <Route
          path={ROUTES.CONTACT}
          element={
            <SuspenseWrapper>
              <ContactInfo />
            </SuspenseWrapper>
          }
        />
        <Route
          path={ROUTES.SETTINGS}
          element={
            <SuspenseWrapper>
              <Settings />
            </SuspenseWrapper>
          }
        />
        <Route path='*' element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
};

export default PageRoutes;
